import React, { forwardRef, useState, useImperativeHandle, useRef } from "react";
import { Stack, Typograph, Box } from "@mui/material";
import PlainTextField from "../../components/InputField/PlainTextField";
import { Input } from "../../components/Input";

const Address = forwardRef((props, ref) => {
    const streetRef = useRef();
    const street2Ref = useRef();
    const cityRef = useRef();
    const stateRef = useRef();
    const zipcodeRef = useRef();

    const refs = [streetRef, street2Ref, cityRef, stateRef, zipcodeRef];
    const [hasError, setHasError] = useState(false);

    const [formValues, setFormValues] = useState(
        props.value ? props.value : { streetAddress1: "", streetAddress2: "", city: "", state: "", zip: "" }
    );

    useImperativeHandle(ref, () => ({
        validate,
    }));

    /*const validate = () => {

    let valid = false;
    valid = props?.isRequired ? ((streetRef.current.validate() && cityRef.current.validate() && stateRef.current.validate() && zipcodeRef.current.validate()) ? true : false) : false;
    setHasError(valid);
    return valid;
  };*/

    const validate = () => {
        let hasError = false;
        for (let i = 0; i < refs.length; i++) {
            if (!refs[i].current.validate()) {
                hasError = true;
            }
        }

        setHasError(!hasError);
        return !hasError;
    };
    const statesOptions = [
        { "id": "AL", "value": "AL", "label": "Alabama" },
        { "id": "AK", "value": "AK", "label": "Alaska" },
        { "id": "AZ", "value": "AZ", "label": "Arizona" },
        { "id": "AR", "value": "AR", "label": "Arkansas" },
        { "id": "CA", "value": "CA", "label": "California" },
        { "id": "CO", "value": "CO", "label": "Colorado" },
        { "id": "CT", "value": "CT", "label": "Connecticut" },
        { "id": "DE", "value": "DE", "label": "Delaware" },
        { "id": "FL", "value": "FL", "label": "Florida" },
        { "id": "GA", "value": "GA", "label": "Georgia" },
        { "id": "HI", "value": "HI", "label": "Hawaii" },
        { "id": "ID", "value": "ID", "label": "Idaho" },
        { "id": "IL", "value": "IL", "label": "Illinois" },
        { "id": "IN", "value": "IN", "label": "Indiana" },
        { "id": "IA", "value": "IA", "label": "Iowa" },
        { "id": "KS", "value": "KS", "label": "Kansas" },
        { "id": "KY", "value": "KY", "label": "Kentucky" },
        { "id": "LA", "value": "LA", "label": "Louisiana" },
        { "id": "ME", "value": "ME", "label": "Maine" },
        { "id": "MD", "value": "MD", "label": "Maryland" },
        { "id": "MA", "value": "MA", "label": "Massachusetts" },
        { "id": "MI", "value": "MI", "label": "Michigan" },
        { "id": "MN", "value": "MN", "label": "Minnesota" },
        { "id": "MS", "value": "MS", "label": "Mississippi" },
        { "id": "MO", "value": "MO", "label": "Missouri" },
        { "id": "MT", "value": "MT", "label": "Montana" },
        { "id": "NE", "value": "NE", "label": "Nebraska" },
        { "id": "NV", "value": "NV", "label": "Nevada" },
        { "id": "NH", "value": "NH", "label": "New Hampshire" },
        { "id": "NJ", "value": "NJ", "label": "New Jersey" },
        { "id": "NM", "value": "NM", "label": "New Mexico" },
        { "id": "NY", "value": "NY", "label": "New York" },
        { "id": "NC", "value": "NC", "label": "North Carolina" },
        { "id": "ND", "value": "ND", "label": "North Dakota" },
        { "id": "OH", "value": "OH", "label": "Ohio" },
        { "id": "OK", "value": "OK", "label": "Oklahoma" },
        { "id": "OR", "value": "OR", "label": "Oregon" },
        { "id": "PA", "value": "PA", "label": "Pennsylvania" },
        { "id": "RI", "value": "RI", "label": "Rhode Island" },
        { "id": "SC", "value": "SC", "label": "South Carolina" },
        { "id": "SD", "value": "SD", "label": "South Dakota" },
        { "id": "TN", "value": "TN", "label": "Tennessee" },
        { "id": "TX", "value": "TX", "label": "Texas" },
        { "id": "UT", "value": "UT", "label": "Utah" },
        { "id": "VT", "value": "VT", "label": "Vermont" },
        { "id": "VA", "value": "VA", "label": "Virginia" },
        { "id": "WA", "value": "WA", "label": "Washington" },
        { "id": "WV", "value": "WV", "label": "West Virginia" },
        { "id": "WI", "value": "WI", "label": "Wisconsin" },
        { "id": "WY", "value": "WY", "label": "Wyoming" },
    ];

    const handleChange = (id, value) => {
        let newFormValues = { ...formValues };
        newFormValues[id] = value;
        setFormValues(newFormValues);
        props.onChange({ ...newFormValues });
    };

    return (
        <div>
            <Stack>
                <Box>
                    <Input
                        {...props.rest}
                        autoFocus
                        type="text"
                        id="streetAddress1"
                        ref={streetRef}
                        label="Street Address 1"
                        name="streetAddress1"
                        value={formValues.streetAddress1}
                        isRequired={true}
                        fullWidth
                        onChange={(value) => handleChange("streetAddress1", value)}
                    />
                </Box>
                <Box sx={{ mt: "5px" }}>
                    <Input
                        {...props.rest}
                        autoFocus
                        type="text"
                        id="streetAddress2"
                        ref={street2Ref}
                        label="Street Address 2"
                        name="streetAddress2"
                        value={formValues.streetAddress2}
                        fullWidth
                        onChange={(value) => handleChange("streetAddress2", value)}
                    />
                </Box>
                <Box sx={{ mt: "5px" }}>
                    <Input
                        {...props.rest}
                        type="text"
                        id="city"
                        ref={cityRef}
                        label="City"
                        name="city"
                        margin="normal"
                        value={formValues.city}
                        isRequired={true}
                        fullWidth
                        onChange={(value) => handleChange("city", value)}
                    />
                </Box>
                <Box sx={{ mt: "5px" }}>
                    <Input
                        {...props.rest}
                        type="select"
                        options={statesOptions}
                        ref={stateRef}
                        id="state"
                        label="State"
                        name="state"
                        margin="normal"
                        value={formValues.state}
                        isRequired={true}
                        fullWidth
                        onChange={(value) => handleChange("state", value)}
                    />
                </Box>
                <Box sx={{ mt: "5px" }}>
                    <Input
                        {...props.rest}
                        id="zipcode"
                        ref={zipcodeRef}
                        type="text"
                        label="Zip code"
                        name="zip"
                        value={formValues.zip}
                        isRequired={true}
                        margin="normal"
                        fullWidth
                        onChange={(value) => handleChange("zip", value)}
                    />
                </Box>
            </Stack>
        </div>
    );
});
export { Address };
